const Table = (props) => {
  const { headData, tableBody, HeadComponent, title, tableHeight } =
    props || {};

  return (
    <div
      className={`overflow-x-auto border border-gray-300 bg-white rounded-xl overflow-hidden relative ${tableHeight}`}
    >
      {!!title && (
        <div
          className={"py-4 border-b border-gray-200 flex-row items-center px-6"}
        >
          <span className="font-semibold text-xl text-gray-900">{title}</span>
        </div>
      )}
      <div className={`table-container overflow-auto h-[88%]`}>
        <table className="min-w-full border border-gray-200 rounded-xl">
          <thead>
            {HeadComponent ? (
              <HeadComponent />
            ) : (
              <tr className="bg-purple-300/70">
                {headData.map((head) => (
                  <th
                    key={head}
                    className="text-left px-6 py-3 text-xs font-medium text-gray-600"
                  >
                    {head}
                  </th>
                ))}
              </tr>
            )}
          </thead>
          <tbody className="bg-white text-center">{tableBody}</tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
